import Header from "../../../components/Header";
import { Card, CardContent, CardMedia, Box, Typography, IconButton } from "@mui/material";
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useTheme } from '@mui/material/styles';
import CardImage from '../../../assets/images/live-from-space.jpg'
import UpIcon from '../../../assets/images/analytics/up_icon.svg'
import DownIcon from '../../../assets/images/analytics/down_icon.svg'

export default function CardWorkflowInfo({
    title,
    yesterday_total,
    now_total,
    changePercent = 0,
    change = 0
}: {
    title: string;
    yesterday_total: number;
    now_total: number;
    changePercent?: number;
    change?: number;
}) {
    const theme = useTheme();
    // const { t } = useTranslation();

    // Xác định tăng hay giảm
    const isIncrease = changePercent > 0;
    const isDecrease = changePercent < 0;
    const isNoChange = changePercent === 0;

    // Màu sắc dựa vào tăng/giảm
    const changeColor = isIncrease ? '#20DF75' : isDecrease ? '#FF4655' : '#7B7B7B';

    // Icon dựa vào tăng/giảm
    const changeIcon = isIncrease ? UpIcon : DownIcon;

    // Text dựa vào tăng/giảm
    const changeText = isIncrease ? 'Up From Last Month' : isDecrease ? 'Down From Last Month' : 'No Change';

    // Format percent với dấu + hoặc -
    const formattedPercent = isNoChange ? '0%' :
        isIncrease ? `+${Math.abs(changePercent)}%` :
        `-${Math.abs(changePercent)}%`;

    return (
        <Card sx={{ backgroundColor: '#FAFAFA', padding: '16px', width: 'calc(100% / 4 - 9px)', borderRadius: '10px', display: 'flex', boxShadow: 'none' }}>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', padding: '0 !important' }} >
                <Typography sx={{ fontSize: '14px', fontWeight: '500', color: '#7B7B7B'}}>
                    {title}
                </Typography>
                <Typography
                    sx={{ fontSize: "36px", color: '#021C5E', fontWeight: 'bold' }}
                >
                    {now_total}
                </Typography>
                <Typography
                    sx={{
                        color: '#7B7B7B', display: 'flex',
                        alignItems: 'center', justifyContent: 'space-between', gap: '8px'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {!isNoChange && <img src={changeIcon} alt="change_icon" />}
                        <span style={{ fontSize: '12px', color: changeColor, fontWeight: 'bold' }}>
                            {formattedPercent}
                        </span>
                    </div>
                    {/* <span style={{ fontSize: '12px', color: '#7B7B7B' }}>{changeText}</span> */}
                </Typography>
            </CardContent>
        </Card>
    );
}